"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Type = _interopRequireDefault(require("./Type1"));

var _Type2 = _interopRequireDefault(require("./Type2"));

var _Type3 = _interopRequireDefault(require("./Type3"));

var _Type4 = _interopRequireDefault(require("./Type4"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TypeMap = {
  Type1: _Type["default"],
  Type2: _Type2["default"],
  Type3: _Type3["default"],
  Type4: _Type4["default"]
};

var LocationInfoSelector = function LocationInfoSelector(props) {
  var Component = TypeMap[props.infoThemeType];
  return /*#__PURE__*/_react["default"].createElement(Component, props);
};

var _default = LocationInfoSelector;
exports["default"] = _default;